export default __webpack_public_path__ + "static/media/3.21cf7fda.png";